import React from 'react'
import classnames from 'classnames'

interface OAuthAlertBannerProps {
  variant: 'danger' | 'warning'
  title: string
  body: string
}

export const OAuthAlertBanner: React.FC<OAuthAlertBannerProps> = ({ variant, title, body }) => {
  const iconClass = variant === 'danger' ? 'bi-exclamation-square' : 'bi-exclamation-triangle'

  return (
    <div className={classnames('oauth-alert-banner p-3 rounded-3 mb-4', `oauth-alert-${variant}`)}>
      <div className='d-flex align-items-center gap-2 mb-1'>
        <i className={classnames('bi', iconClass, 'oauth-alert-icon')} />
        <span className='fw-bold text-body'>{title}</span>
      </div>
      <div className='text-body ps-4'>{body}</div>
    </div>
  )
}
